"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.articlesSectionProps = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
const articlesSectionProps = exports.articlesSectionProps = {
  articles: _editorialFetching.articles,
  countOfArticles: _editorialFetching.articles.length,
  labelRead: 'Read now',
  loadMoreButtonText: 'Load more',
  mode: 'featured',
  title: 'Featured articles',
  getPaginationInfoText: (value, max) => `Showing ${value} out of ${max} articles`
};
